import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectedCliente } from "./types";

type Entity = SelectedCliente;
export interface Deps {
    onSeleccionar: (x: Entity, value: boolean) => void;
}
export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        { title: "", key: "seleccionar", cell: x => ({ data: x.Selected, view: () => <kea.Checkbox value={x.Selected} onChange={sel => deps.onSeleccionar(x, sel)} /> }) },
        ...columnasFijas
    ];

    const rowStyleCol = kea.applyRowStyleToColumns(ret, (item: Entity) =>
        item.Selected ? { background: "#F7F7D4" } : {});
    return rowStyleCol;
}


export const columnasFijas: kea.Grid2Column<Entity>[] = [

    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Teléfono", cell: x => ({ data: x.Telefono }) },

    { title: "Acepta flete por cobrar", cell: x => ({ data: x.AceptaFletePorCobrar }) },
    { title: "Tarifa", cell: x => ({ data: x.NombreTarifa }) },

    { title: "Vendedor", cell: x => ({ data: x.NombreVendedor }) },
    { title: "Direccion de facturación", cell: x => ({ data: x.DireccionFacturacion }) },
    { title: "Tipo persona", cell: cli => ({ data: nullsafe(cli.TipoPersona, x => models.TipoPersona[x]) }) },
    { title: "Limite de credito", cell: x => ({ data: x.LimiteCredito, view: kea.formatCurrency }) },

    { title: "Cargos de crédito", cell: x => ({ data: x.CargoCredito, view: kea.formatCurrency }) },
    { title: "Abonos de crédito", cell: x => ({ data: x.AbonoCredito, view: kea.formatCurrency }) },
    { title: "Saldo de crédito", cell: x => ({ data: x.SaldoCredito, view: kea.formatCurrency }) },

    { title: "Dia de cobranza", cell: x => ({ data: models.DiaSemana[x.DiaCobranza] }) },
    { title: "Dia de revisión", cell: x => ({ data: models.DiaSemana[x.DiaRevision] }) },
    { title: "Sucursal de cobranza", cell: x => ({ data: x.IataSucursalCobranza }) },
]


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/clientesfinales/columns.tsx